import { render } from "./pricingView.vue?vue&type=template&id=d60289e8"
import script from "./pricingView.vue?vue&type=script&lang=js"
export * from "./pricingView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__